import { centerCrop, makeAspectCrop } from "react-image-crop";

export const centerAspectCrop = (
  mediaWidth: number,
  mediaHeight: number,
  aspect: number,
  cropPercentWidth: number
) =>
  centerCrop(
    makeAspectCrop(
      {
        unit: "%",
        width: cropPercentWidth,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
